import template from '../../templates/Keyword/main.template';
import Component from '../../core/component';

export default class Main extends Component {
  constructor(data) {
    super(template, data);
  }
}
